import { memo } from 'react'

import { MarkerOptions } from '../../lib/types'

interface YandexMarkerProps {
  id: string
  latitude: number
  longitude: number
  options?: MarkerOptions
  YMapMarker: any
  reactify: any
}

/**
 * Мемоизированный компонент маркера для Yandex MapsConfigs.tsx
 * useDefault используется на верхнем уровне компонента (не в цикле!)
 * Это соответствует правилам React хуков
 */
export const YandexMarker = memo<YandexMarkerProps>(
  ({ latitude, longitude, YMapMarker, reactify, options }) => {
    // ✅ ПРАВИЛЬНО: useDefault на верхнем уровне компонента
    // Yandex MapsConfigs.tsx ожидает координаты в формате [longitude, latitude]
    const coordinates = reactify.useDefault([longitude, latitude], [longitude, latitude])

    return (
      <YMapMarker coordinates={coordinates}>
        {options?.title && (
          <div
            style={{
              backgroundColor: options.color || '#FF0000',
              padding: '4px 8px',
              borderRadius: '4px',
              color: 'white',
              fontSize: '12px',
              whiteSpace: 'nowrap',
              boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
            }}
          >
            {options.title}
          </div>
        )}
      </YMapMarker>
    )
  },
  // Перерисовываем только при изменении координат или опций
  (prev, next) =>
    prev.latitude === next.latitude &&
    prev.longitude === next.longitude &&
    prev.options?.color === next.options?.color &&
    prev.options?.title === next.options?.title
)

YandexMarker.displayName = 'YandexMarker'
